
import { Component, Vue, Prop } from "vue-property-decorator";
import IntroduceCard from "@/views/ai-builder-component/components/introduce-card.vue";
import HinaSwitch from "@/views/ai-builder-component/baseComponent/hina-switch.vue";
import HinaRadioGroup from "@/views/ai-builder-component/baseComponent/hina-radio-group.vue";
import InputNumberV3 from "@/views/ai-builder-v3/components/inputNumberV3.vue";
import { ExamVersionInfo } from "@/lib/model/exambuilder/exam-component/exam";

@Component({
  components: {
    IntroduceCard,
    HinaSwitch,
    HinaRadioGroup,
    InputNumberV3
  }
})
export default class CertPhoto extends Vue {
  @Prop({}) formItemData!: ExamVersionInfo;

  rules = {};

  changeValid(val: number) {
    if (val !== 1) {
      this.$emit("setBar", false);
    }
  }
}
